import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Vite exposes anything prefixed VITE_ to the bundle. Both URL and the publishable
// (anon) key are browser-safe. The service-role key is NEVER imported here — it stays
// server-side and is only used inside Supabase edge functions.
const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error(
    'Missing Supabase env. Copy apps/mobile/.env.local.example to .env.local and fill in VITE_SUPABASE_URL + VITE_SUPABASE_ANON_KEY.'
  );
}

// Don't annotate `supabase` with an explicit SupabaseClient<Database> type — let it
// infer from createClient<Database>() so the full generic chain (Schema, ClientOptions,
// SchemaName) flows through. Annotating with just `SupabaseClient<Database>` truncates
// the inference and collapses Schema to `never`, which is why every insert/update
// previously typed as `never` and required @ts-expect-error workarounds.
export const supabase = createClient<Database>(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
